module.exports = __webpack_public_path__ + "static/img/camp2.6cd74ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/camp2.jpg
// module id = c325
// module chunks = 0